import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const KONTAKT_ROUTES: AppRoutes = [
    {
        path: "info",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den YSTM',
                to: 'INFO_MANAGER'
            },
            meta: {
                description: 'Nachricht an den YSTM - Allgemein'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "vorsitzender",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den YSTM-Vorsitzenden',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den YSTM-Vorsitzenden',
                to: 'CHAIRMAN'
            },
            meta: {
                description: 'Nachricht an den YSTM-Vorsitzenden'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "stellv-vorsitzender",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den stellvertretenden YSTM-Vorsitzenden',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den stellvertretenden YSTM-Vorsitzenden',
                to: 'DEPUTY_CHAIRMAN'
            },
            meta: {
                description: 'Nachricht an den stellvertretenden YSTM-Vorsitzenden'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "kassenwart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Kassenwart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Kassenwart des YSTM',
                to: 'TREASURER'
            },
            meta: {
                description: 'Nachricht an den Kassenwart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "schriftwart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Schriftwart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Schriftwart des YSTM',
                to: 'SECRETARY'
            },
            meta: {
                description: 'Nachricht an den Schriftwart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "sportwart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Sportwart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Sportwart des YSTM',
                to: 'SPORTS_OFFICER'
            },
            meta: {
                description: 'Nachricht an den Sportwart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "grundstückswart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Grundstückswart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Grundstückswart des YSTM',
                to: 'PROPERTY_MANAGER'
            },
            meta: {
                description: 'Nachricht an den Grundstückswart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "jugendwart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Jugendwart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Jugendwart des YSTM',
                to: 'YOUTH_OFFICER'
            },
            meta: {
                description: 'Nachricht an den Jugendwart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "zeug-wart",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Zeug-Wart des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Zeug-Wart des YSTM',
                to: 'EQUIPMENT_MANAGER'
            },
            meta: {
                description: 'Nachricht an den Zeug-Wart des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "rote-zora",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an die Eigenrinnen-Gemeinschaft "Rote Zora"',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an die Eigenrinnen-Gemeinschaft "Rote Zora"',
                to: 'ROTE_ZORA'
            },
            meta: {
                description: 'Nachricht an die Eigenrinnen-Gemeinschaft "Rote Zora"'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "support",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den YSTM-Support',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den YSTM-Support',
                to: 'SUPPORT_MANAGER'
            },
            meta: {
                description: 'Nachricht an den YSTM-Support'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "events",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den YSTM-Event-Manager',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den YSTM-Event-Manager',
                to: 'EVENT_MANAGER'
            },
            meta: {
                description: 'Nachricht an den YSTM-Event-Manager'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "gastronomie",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an die Gastronomie des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an die Gastronomie des YSTM',
                to: 'GASTRONOMY_MANAGER'
            },
            meta: {
                description: 'Nachricht an die Gastronomie des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "webmaster",
        loadComponent: () => import('../../modules/ystm-contact/components/direct-contact-shell/direct-contact-shell.component').then(mod => mod.DirectContactShellComponent),
        title: 'Nachricht an den Webmaster des YSTM',
        data: {
            header: {
                type: 'back_button',
            },
            directContactShellData: {
                context: 'Ihre Nachricht an den Webmaster des YSTM',
                to: 'WEBMASTER'
            },
            meta: {
                description: 'Nachricht an den Webmaster des YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "",
        loadComponent: () => import('./components/kontakt-carousel/kontakt-carousel.component').then(mod => mod.KontaktCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/kontakt-home/kontakt-home.component').then(mod => mod.KontaktHomeComponent),
        title: 'YSTM - Kontakt',
        data: {
            meta: {
                description: 'YSTM Kontakte, Nachrichten an den YSTM'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];